import { useSelector } from 'react-redux';
import { Kimh2024EventBanner } from './kimh2024-event-banner/Kimh2024EventBanner';
import { VM2025EventBanner } from './vm2025-event-banner/VM2025EventBanner';
import { useProject } from '../project-hooks/useProject';
import MSMProjectBanner from './msm2025-event-banner/MSMProjectBanner';
import TvaMotivationalBanner from '../../campaign/tv-aksjonen/banner/tva-motivational-banner';
import DefaultEventBanner from './DefaultEventBanner';

const ProjectEventBanner = () => {
    const project = useProject();
    const kimh2024EventId = useSelector((state) => parseInt(state.campaigns.kimh2024EventId, 10));
    const vm2025EventId = useSelector((state) => parseInt(state.campaigns.vm2025EventId, 10));
    const msm2025EventId = useSelector((state) => parseInt(state.campaigns.msm2025EventId, 10));
    const tva2025EventId = useSelector((state) => parseInt(state.campaigns.tvaEventId, 10));

    switch (project?.event_id) {
        case kimh2024EventId:
            return <Kimh2024EventBanner />;
        case vm2025EventId:
            return <VM2025EventBanner />;
        case msm2025EventId:
            return <MSMProjectBanner />;
        case tva2025EventId:
            return <TvaMotivationalBanner />;
        default:
            return <DefaultEventBanner />;
    }
};

export default ProjectEventBanner;
